import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './components/landingPage';
import Register from './components/Register';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Matches from './components/Matches';
import EditProfile from './components/EditProfile';
import { ToastProvider } from './components/ui';
import Inbox from './components/Inbox';
import { Sessions, SessionDetail } from './components/Sessions';
import { Groups } from './components/Groups';

function App() {
  return (
    <ToastProvider>
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/matches" element={<Matches />} />
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/inbox/:type/:id" element={<Inbox />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/sessions/:id" element={<SessionDetail />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/join/:code" element={<Groups />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
    </ToastProvider>
  );
}

export default App;
